import { faEdit, faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import CommonUtil from "../../../utils/CommonUtil";
import ProcessComponent from "../ProcessComponent";
import SubmitControl from "../SubmitControl";
import EditableLink from "./EditableLink";

class EditableLinkContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false // default editing mode
    };
  }

  /*
   * render a form, that changes the label
   * change the editing mode, when submitting
   */
  renderEdit = () => {
    return (
      <Form>
        <Row>
          <Col>
            <SubmitControl
              type="text"
              title={this.props.title}
              value={this.props.value}
              onChange={this.changeValue}
              placeholder={this.props.placeholder}
              processes={this.props.processes}
              partyId={this.props.partyId}
              readOnly={this.props.readOnly}
            />
          </Col>
          <Col xs="auto" sm="auto">
            <Button variant="link" onClick={this.changeEdit(false)}>
              <FontAwesomeIcon icon={faPencilAlt} size="lg" />
            </Button>
          </Col>
        </Row>
      </Form>
    );
  };

  changeValue = e => {
    if (!this.state.edit) {
      this.setState({ edit: true });
    }
    this.props.changeLinkValue(e);
  };

  renderLabel = () => {
    const value = CommonUtil.ifNotExternalLinkCreateHttp(this.props.value);

    return (
      <Form>
        <Row>
          <Col>
            <a
              className="link-div"
              href={value}
              target="_blank"
              rel="noopener noreferrer"
            >
              {this.props.value}
            </a>
          </Col>
          <ProcessComponent processes={this.props.processes}>
            {this.props.disabled ? null : (
              <Col xs="auto" sm="auto">
                <Button variant="link" onClick={this.changeEdit(true)}>
                  <FontAwesomeIcon icon={faEdit} size="lg" />
                </Button>
              </Col>
            )}
          </ProcessComponent>
        </Row>
      </Form>
    );
  };

  /*
   * return a function for your events, that changes the editing mode
   */
  changeEdit = edit => {
    return e => {
      e.preventDefault();

      this.setState({ edit });
    };
  };

  render() {
    const outputRender =
      (this.state.edit || !this.props.value) && !this.props.disabled
        ? this.renderEdit()
        : this.renderLabel();
    return <EditableLink output={outputRender} />;
  }
}

export default EditableLinkContainer;
